import { StateUtils } from '@spartacus/core';
import { PalletFlagType, PalletFlags, PalletFlagsRequest } from '../../../../../core/model';
import { CartEntryPalletFlagsActionTypes } from '../actions/cart-entry-pallet-flags.action';
import { CartActions } from '../actions/index';

export const initialState: PalletFlags = undefined;

export function reducer(
  state = initialState,
  action: CartActions.CartEntryPalletFlagsActions | StateUtils.LoaderAction
): PalletFlags {
  switch (action.type) {
    case CartEntryPalletFlagsActionTypes.UpdateCartEntryPalletFlagsSuccess: {
      const palletFlags: PalletFlagsRequest = action.payload.palletFlags;
      const newState: PalletFlags = {};
      palletFlags.flags.map((palletFlag) => {
        switch (palletFlag.type) {
          case PalletFlagType.CUSTOMER:
            newState.customer = palletFlag.value;
            break;
          case PalletFlagType.MACHINE_NO:
            newState.machine = palletFlag.value;
            break;
          case PalletFlagType.OBJECT:
            newState.object = palletFlag.value;
            break;
          default:
            throw new Error('Unknown pallet flag type');
        }
      });
      return {
        ...state,
        ...newState,
      };
    }
  }
  return state;
}
